module.exports = __webpack_public_path__ + "img/ggt.1b953b76.png";